import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      d="M12.75 6.707A4.386 4.386 0 0 1 16.247 5c1.328 0 2.45.583 3.185 1.318a4.5 4.5 0 0 1 0 6.364L12.75 19l-6.682-6.318a4.5 4.5 0 0 1 0-6.364C6.81 5.576 8.006 5 9.248 5c1.244 0 2.68.576 3.502 1.707Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.75 12c-.001 0-.001 0 0 0Z"
      clipRule="evenodd"
    />
  </>,
  'HeartFilled',
  '4 4 17 16',
);
